import { Controller } from 'stimulus';

export default class extends Controller {
  static values = {
    name: String,
  };

  /**
   * @param {Event} e
   */
  dispatch(e) {
    super.dispatch(`${this.nameValue}:${e.type}`, {
      prefix: null,
    });
  }
}
